/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';

const OrganizationSpaceSvg = ({ color }) => (
  <svg width="1em" height="1em" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2736_8821" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="23">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.0678 1.94395C17.4429 3.07954 16.9585 4.31458 15.9934 4.93372C15.6439 5.15801 15.3768 5.53342 15.4261 5.94583L15.9053 9.95339C15.9581 10.3948 16.3435 10.7145 16.7863 10.7536C19.1175 10.9593 21.2164 12.5171 21.9973 14.8803C23.0445 18.0502 21.3239 21.4689 18.154 22.5162C14.9841 23.5635 11.5655 21.8428 10.5182 18.6729C10.1239 17.4797 10.1219 16.2512 10.4418 15.1271C10.5632 14.7008 10.4027 14.2284 10.0108 14.0212L7.50036 12.6947C7.13452 12.5014 6.68922 12.6092 6.37571 12.8793C6.03461 13.173 5.63139 13.4062 5.17736 13.5562C3.32234 14.1691 1.32171 13.1621 0.70883 11.3071C0.0959466 9.45208 1.1029 7.45145 2.95792 6.83857C4.05027 6.47766 5.19313 6.67846 6.07336 7.28336C6.42124 7.52242 6.88729 7.57853 7.23181 7.33467L11.6864 4.18148C12.0147 3.94914 12.119 3.51851 12.0651 3.11998C11.9034 1.92487 12.6089 0.698782 13.8072 0.302873C15.1608 -0.144324 16.6206 0.590409 17.0678 1.94395ZM8.0153 11.9413C7.62496 11.7351 7.4689 11.2643 7.54653 10.8297C7.6438 10.2851 7.61279 9.72109 7.45712 9.19051C7.33546 8.77587 7.43345 8.3028 7.78615 8.05315L12.1535 4.96178C12.4972 4.71849 12.9616 4.77853 13.3263 4.98895C13.4621 5.0673 13.6049 5.13327 13.7528 5.18592C14.1373 5.32284 14.4743 5.62253 14.5228 6.0278L15.0049 10.0606C15.0577 10.5022 14.7584 10.9038 14.3371 11.0463C13.2664 11.4084 12.3065 12.0683 11.5868 12.9409C11.3027 13.2853 10.8184 13.4225 10.4236 13.2139L8.0153 11.9413Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2736_8821)">
      <rect x="15.7764" y="-1.13184" width="23.1096" height="6.62441" transform="rotate(64.2147 15.7764 -1.13184)" fill={color === 'primary' ? '#3A3F54' : color === 'transparent' ? 'rgba(255, 255, 255, 0.5)' : 'currentColor'} />
      <rect x="9.74023" y="1.41504" width="23.1583" height="6.89509" transform="rotate(64.2147 9.74023 1.41504)" fill={color === 'primary' ? '#505776' : color === 'transparent' ? 'rgba(255, 255, 255, 0.75)' : 'currentColor'} />
      <rect x="3.44287" y="4.1543" width="20.432" height="5.73971" transform="rotate(64.2147 3.44287 4.1543)" fill={color === 'primary' ? '#8E97BC' : color === 'transparent' ? '#FFFFFF' : 'currentColor'} />
    </g>
  </svg>
);

export const OrganizationSpaceIcon = props => {
  const { color, ...restProps } = props;
  return (
    <Icon
      component={() => <OrganizationSpaceSvg color={color} />}
      {...restProps}
    />
  );
};

OrganizationSpaceSvg.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};

OrganizationSpaceIcon.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};
